import { render, staticRenderFns } from "./CartProducts.vue?vue&type=template&id=07a03975&scoped=true"
import script from "./CartProducts.vue?vue&type=script&lang=js"
export * from "./CartProducts.vue?vue&type=script&lang=js"
import style0 from "./CartProducts.vue?vue&type=style&index=0&id=07a03975&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a03975",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a03975')) {
      api.createRecord('07a03975', component.options)
    } else {
      api.reload('07a03975', component.options)
    }
    module.hot.accept("./CartProducts.vue?vue&type=template&id=07a03975&scoped=true", function () {
      api.rerender('07a03975', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/CartProducts.vue"
export default component.exports